import { rootApi } from "./rootApi";

export const staffEndpoints = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getStaffClassLinks: builder.query<{ mainClassIds: string[]; linkedClassIds: string[] }, { staffId: string; schoolId: string }>({
      query: ({ staffId, schoolId }) => ({
        type: 'select',
        table: 'staff_class_links',
        params: {
          select: 'class_id,is_class_teacher,role',
          staff_id: staffId,
          school_id: schoolId,
        },
      }),
      transformResponse: (response: any[]) => {
        const mainClassIds: string[] = [];
        const linkedClassIds: string[] = [];
        
        for (const row of response) {
          if (!row.class_id) continue;
          
          linkedClassIds.push(row.class_id);
          
          const isMain = row.is_class_teacher === true || 
            ['klassenleitung', 'class_lead', 'main'].includes(String(row.role || '').toLowerCase());
            
          if (isMain) {
            mainClassIds.push(row.class_id);
          }
        }
        
        return { mainClassIds, linkedClassIds };
      },
      providesTags: ['Classes', 'Staff'],
      keepUnusedDataFor: 300, // cache for 5 minutes
    }),
  }),
});

export const { useGetStaffClassLinksQuery } = staffEndpoints;
